import { RegistrationFormValues, LoginFormValues } from "./types";

export const initialLoginForm: LoginFormValues = {
  email: null,
  password: null,
  keepLoggedIn: false,
};

export const initialRegistrationForm: RegistrationFormValues = {
  tenantType: null,
  firstName: null,
  lastName: null,
  companyName: null,
  taxNumber: null,
  email: null,
  password: null,
  confirmPassword: null,
};
